import { useMutation } from "@tanstack/react-query";

import { Prices } from "../../../api/prices";
import { MutationKey } from "../../../consts/mutation-keys";
import { QueryKey } from "../../../consts/query-keys";
import { useApiError } from "../../../hooks/useApiError";
import { useApiSuccess } from "../../../hooks/useApiSuccess";

export type PriceDeletePayload = {
  productId: number;
  regionId: number;
};

export function useDeletePrice(successFn?: () => void) {
  const { handleSuccess } = useApiSuccess({
    snackbarText: "Price removed.",
    invalidate: [[QueryKey.Products], [QueryKey.RegionPrices]],
    onSuccessFn: successFn,
  });

  const { handleError, apiErrors, clearApiErrors } = useApiError();

  const mutationFn = ({ productId, regionId }: PriceDeletePayload) => {
    return Prices.delete({
      path: { productId: productId, regionId: regionId },
    });
  };

  const { mutate: deletePrice, isPending } = useMutation({
    mutationKey: [MutationKey.DeletePrice],
    mutationFn: mutationFn,
    onSuccess: handleSuccess,
    onError: handleError,
    retry: 0,
  });

  return { deletePrice, isPending, apiErrors, clearApiErrors };
}
